module.exports = __webpack_public_path__ + "img/fond_neutre.09745cf7.jpg";